'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _actionTypes = require('../constants/action-types');

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {};

var queries = function queries() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case actionTypes.RESET:
            {
                return {};
            }
        case actionTypes.MUTATE_START:
        case actionTypes.REQUEST_START:
            {
                var queryKey = action.queryKey;


                return (0, _lodash2.default)(state, queryKey);
            }
        case actionTypes.MUTATE_FAILURE:
        case actionTypes.REQUEST_FAILURE:
            {
                var _queryKey = action.queryKey;


                return _extends({}, state, _defineProperty({}, _queryKey, _extends({}, state[_queryKey], {
                    responseBody: action.responseBody,
                    responseText: action.responseText,
                    responseHeaders: action.responseHeaders
                })));
            }
        default:
            {
                return state;
            }
    }
};

exports.default = queries;


/*****************
 ** WEBPACK FOOTER
 ** ../~/redux-query/dist/commonjs/reducers/errors.js
 ** module id = 316
 ** module chunks = 3
 **/